import { ThemeOptions } from '@mui/material';

import * as MuiAlert from './MuiAlert';
import * as MuiCircularProgress from './MuiCircularProgress';
import * as MuiDialog from './MuiDialog';
import * as MuiLinearProgress from './MuiLinearProgress';
import * as MuiSkeleton from './MuiSkeleton';
import * as MuiSnackbar from './MuiSnackbar';

export type {} from './MuiAlert';
export type {} from './MuiCircularProgress';
export type {} from './MuiDialog';
export type {} from './MuiSkeleton';
export type {} from './MuiSnackbar';

export const feedback: ThemeOptions['components'] = {
  ...MuiCircularProgress,
  ...MuiLinearProgress,
  ...MuiAlert,
  ...MuiDialog,
  ...MuiSkeleton,
  ...MuiSnackbar
};
